export default __webpack_public_path__ + "static/media/product-03 (1).a77fd6ed.jpg";